import $ from 'jquery'
;(function () {
	'use strict'
	function showGDPRNotice(elemSelector, serviceName) {
		if (typeof UC_UI === 'undefined') {
			return
		}

		const elem = document.querySelector(elemSelector)
		if (!elem) {
			return
		}

		const parent = elem.parentElement
		if (parent) {
			parent.style.position = 'relative'

			if (!parent.querySelector('.uc-gdpr-notice')) {
				const noticeDiv = document.createElement('div')
				noticeDiv.className = 'uc-gdpr-notice'
				noticeDiv.innerHTML = `<p>${serviceName} können aus Datenschutzgründen nicht angezeigt werden. Um die Inhalte zu laden, aktivieren Sie den Service in Ihren <a href="javascript:void(0)" onclick="UC_UI.showSecondLayer();">Privatsphäre-Einstellungen</a>.</p>`
				parent.appendChild(noticeDiv)
			}
		}
	}

	window.addEventListener('load', function (event) {
		setTimeout(() => {
			if (typeof UC_UI === 'undefined') {
				return
			}

			const serviceInfo = UC_UI.getServicesBaseInfo().find(data => data.id === 'w4TLMK1UMCIODw')
			if (!serviceInfo) {
				return
			}

			const adventskalenderElems = document.querySelectorAll('.adventskalender')
			const scriptElement = document.createElement('script')

			if (serviceInfo.consent.status === true) {
				adventskalenderElems.forEach(elem => {
					elem.setAttribute('src', elem.getAttribute('data-src'))
				})

				scriptElement.type = 'text/javascript'
				scriptElement.src = 'https://tuerchen.app/embed.js?da39a3ee&quot'
				document.body.appendChild(scriptElement)
			} else if (serviceInfo.consent.status === false) {
				showGDPRNotice('.adventskalender', 'Türchen (Adventskalender)')
			}
		}, 2000)
	})

	if (!window.UC_UI || !UC_UI.isInitialized()) {
		window.addEventListener('UC_UI_INITIALIZED', function () {
			matomoConsentHandler()
		})
	} else {
		matomoConsentHandler()
	}

	function matomoConsentHandler(reloadWhenNoConsent = false) {
		const serviceInfo = UC_UI.getServicesBaseInfo().find(service => service.id === 'u6fxocwTs')
		if (serviceInfo && serviceInfo.consent.status === true) {
			_paq.push(['setConsentGiven'])
		} else if (reloadWhenNoConsent) {
			window.location.reload()
		}
	}

	/**
	 * Updates content based on (changed) privacy settings
	 *
	 * @param   {event}  ucEvent   Custom event by Usercentrics, event name can be defined in the Usercentrics control panel
	 */
	window.addEventListener('ucEvent', function (e) {
		if (e.detail && e.detail.event === 'consent_status' && e.detail.action !== 'onInitialPageLoad') {
			const adventskalenderElems = document.querySelectorAll('.adventskalender')
			const scriptElement = document.createElement('script')

			if (e.detail['Türchen (Adventskalender)'] === true) {
				adventskalenderElems.forEach(elem => {
					elem.setAttribute('src', elem.getAttribute('data-src'))

					scriptElement.type = 'text/javascript'
					scriptElement.src = 'https://tuerchen.app/embed.js?da39a3ee&quot'
					document.body.appendChild(scriptElement)
				})
				adventskalenderElems.forEach(elem => {
					const notice = elem.parentElement.querySelector('.uc-gdpr-notice')
					if (notice) {
						notice.remove()
					}
				})
			} else if (e.detail['Türchen (Adventskalender)'] === false) {
				adventskalenderElems.forEach(elem => {
					elem.removeAttribute('src')
				})
				showGDPRNotice('.adventskalender', 'Türchen (Adventskalender)')
			}

			// Matomo
			matomoConsentHandler(true)
		}
	})
})()
